<template>
    <div class="minhas-licitacoes-hoje mt-3">
        <minhas-licitacoes-titulo-secao titulo="Licitações Acontecendo Hoje"/>
        <az-container>
            <az-form>
                <div class="content" v-if="temLicitacoesHoje">
                    <div class="cards-warning">
                        <div :class="getCardClass(index)" v-for="(licitacao, index) in licitacoes" :key="licitacao.id">
                            <span class="number">Edital: {{licitacao.numeroEdital}}</span>
                            <v-tooltip top max-width=750>
                                <span slot="activator" class="msg-big">{{licitacao.orgao.nome | az-clip-text(50)}}</span>
                                <span>{{licitacao.orgao.nome}}</span>
                            </v-tooltip>
                            <v-tooltip top max-width=750>
                                <span slot="activator" class="msg-small">{{licitacao.objeto | az-clip-text(50)}}</span>
                                <span>{{licitacao.objeto}}</span>
                            </v-tooltip>
                            <v-btn id="labelBotaoParticipar" class="action no-mobile" color="secondary" :outline="!podeAcessarPregao(licitacao)" @click="acessarPregao(licitacao)">
                                {{getLabelBotaoParticipar(licitacao)}}
                            </v-btn>
                            <span id="labelBotaoParticiparMobile" class="msg-small mobile">{{getLabelBotaoParticipar(licitacao, true)}}</span>
                        </div>
                    </div>
                </div>
                <div v-else class="ops">
                    Nenhuma licitação acontecendo hoje.
                </div>
            </az-form>
        </az-container>
    </div>
</template>

<script>
    import MinhasLicitacoesTituloSecao from './MinhasLicitacoesTituloSecao'

    export default {
        name: 'MinhasLicitacoesHoje',
        components: {MinhasLicitacoesTituloSecao},
        props: {
            licitacoes: {
                type: Array,
                required: true
            }
        },
        computed: {
            temLicitacoesHoje() {
                return this.licitacoes.length > 0
            }
        },
        methods: {
            getCardClass(index) {
                return {
                    item: true,
                    'no-border': index === 0 ? true : false
                }
            },
            getLabelBotaoParticipar(licitacao, isMobile) {
                if (this.podeAcessarPregao(licitacao) && !isMobile) {
                    return 'Participar'
                }
                return `Hoje - ${this.$options.filters['az-date'](licitacao.dataAbertura,'HH:mm')}`
            }
        }
    }
</script>

<style lang="stylus">
    .minhas-licitacoes-hoje
        .ops
            width: 100%
            display: block
            text-align: center
            padding: 50px
            background-color: white
            font-weight: bold
            color: #3a6861
            font-size: 16px
        .az-container
            margin: 0 !important
            background-color: transparent !important
        .left
            padding-right 10px
        .right
            padding-left 10px
        .content
            background-color white
            padding: 20px
            border-radius 10px
            height 100%

            .cards-warning
                display flex
                align-items center
                .no-border
                    border none !important
                .item
                    display block
                    width 25%
                    padding 0 30px
                    border-left 1px solid #ccc
                    .msg-big
                        font-weight bold
                        color #777
                        display block
                    .msg-small
                        color #777
                        display block
                    .number
                        display block
                        font-size 16px
                        font-weight bold
                        color #3a6861
                        padding 3px 0
                    .action
                        padding 5px 0
                        font-weight bold
                        width 160px
                        margin-top 5px
                        border-radius 2px
                        text-align center
                        margin-left 0 !important
                        text-transform none !important
    @media (min-width: 720px)
        .mobile
            display: none !important
    @media (max-width: 720px)
        .cards-warning
            display block !important
            .no-border
                border unset !important
            .item
                border-left: none !important
                border-top 1px solid #ccc
                width: 100% !important
                padding: 20px 0 !important
</style>
